import { render, staticRenderFns } from "./SelectImage.template.vue?vue&type=template&id=65e055e5&scoped=true&"
var script = {}
import style0 from "./SelectImage.template.vue?vue&type=style&index=0&id=65e055e5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e055e5",
  null
  
)

export default component.exports